import React, { useEffect } from 'react'

import { useShoppingCartContext } from '../../../functional-components/ShoppingCart/context/ShoppingCartContext'
import { useIsTenant } from '../../../contexts/TenantContext'
import useWindowSize from '../../../hooks/useWindowSize'

import constants from '../../../common/constants'
import ProductDetailPage from '..'
import useTags from '../../../functional-components/Tags/hooks/useTags'

const ProductDetail = (props) => {
  const { store } = useShoppingCartContext()
  const { isMobile } = useWindowSize()
  const isSod = useIsTenant(constants.tenant.SOD)

  const { handleTags } = useTags()

  useEffect(() => {
    const getTags = async () => await handleTags()
    getTags()
  }, [])

  const productDetailProps = {
    ...props,
    selectedSODStoreId: isSod && store ? store.id : undefined,
    isSod,
    isMobile,
    showLegalInfo: !isSod,
  }

  return <ProductDetailPage {...productDetailProps} />
}

export default ProductDetail
